document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".flickity-page-dots, .flickity-button")) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }

    const swatch = e.target.closest(".color-available .swatch-element");
    if (!swatch) return;

    const allSwatches =
      swatch.parentElement?.querySelectorAll(".swatch-element");
    if (allSwatches) {
      allSwatches.forEach((el) => el.classList.remove("active"));
    }
    swatch.classList.add("active");

    const loc = swatch.dataset.bg || "";
    const vari = swatch.dataset.value || "";
    const cls = swatch.dataset.productId || "";
    const variantId = swatch.dataset.variantId || "";
    const price = swatch.dataset.price || "";
    const oldPrice = swatch.dataset.oldPrice || "";
    const getUrl = swatch.dataset.url || "";

    const productInfo = swatch.closest(".product-information");
    if (productInfo) {
      const titleEl = productInfo.querySelector(".varaint_title");
      if (titleEl) titleEl.innerHTML = vari;

      const priceEl = productInfo.querySelector(".main_price");
      if (priceEl) {
        if (price !== "") {
          if (oldPrice !== "") {
            const oldSpan = `<span class="old-price" style="margin: 0;">${oldPrice}</span>`;
            priceEl.innerHTML = `From ${oldSpan} ${price}`;
          } else {
            priceEl.innerHTML = `From ${price}`;
          }
        }
      }
    }

    const main = document.querySelector("." + CSS.escape(cls));
    if (main) {
      main.setAttribute("data-bgset", loc);

      const bgInners = main.querySelectorAll(".product-item__bg__inner");
      bgInners.forEach((el) => el.classList.remove("is-visible"));

      const visibleEl = main.querySelector(
        ".product-item__bg__inner." + CSS.escape(variantId)
      );
      if (visibleEl) visibleEl.classList.add("is-visible");

      const slider = main.querySelector('.flickity-slider');
      if (slider) {
        const targetSlide = slider.querySelector(`.${CSS.escape(variantId)}`);
        if (targetSlide) {
          const flickityElement = slider.closest('.flickity-enabled');
          if (flickityElement && window.theme && window.theme.Flickity) {
            const flkty = window.theme.Flickity.data(flickityElement);
            if (flkty) {
              const slideIndex = flkty.getCellElements().findIndex(el => el === targetSlide);
              if (slideIndex !== -1) {
                flkty.select(slideIndex, true, true);
              }
            }
          }
        }
      }

      const variantTitleEl = main.querySelector(".variant-option-title");
      if (variantTitleEl) variantTitleEl.innerHTML = vari;
    }

    const productItem = swatch.closest(".product-item");
    if (productItem && getUrl !== "") {
      const links = productItem.querySelectorAll("a");
      links.forEach((a) => a.setAttribute("href", getUrl));
    }
  });
});

const initCollectionFilters = () => {
  const filterButtons = document.querySelectorAll(".btn-filter");
  const collectionFiltersForm = document.querySelector("collection-filters-form");
  const viewAllButton = document.querySelector(".btn-view-all");
  viewAllButton?.classList.add("active");

  if (!filterButtons.length || !collectionFiltersForm) return;

  // Check and set active state based on checked checkboxes
  const checkedCheckboxes = document.querySelectorAll(
    '.collection-nav.filter-by-metafields input[type="checkbox"]:checked'
  );

  if (checkedCheckboxes.length === 0) {
    // No checkboxes selected → activate "View All"
    viewAllButton?.classList.add("active");
    filterButtons.forEach((button) => {
      if (!button.classList.contains("btn-view-all")) {
        button.classList.remove("active");
      }
    });
  } else {
    // Some checkboxes selected → deactivate "View All"
    viewAllButton?.classList.remove("active");
    filterButtons.forEach((button) => {
      if (!button.classList.contains("btn-view-all")) {
        const filterValue = button.textContent.trim();
        const checkbox = Array.from(checkedCheckboxes).find((cb) => {
          const label = cb.nextElementSibling;
          return label && label.textContent.trim() === filterValue;
        });
        button.classList.toggle("active", checkbox !== undefined);
      }
    });
  }

  // Handle "View All" click → uncheck all checkboxes
  if (viewAllButton) {
    viewAllButton.addEventListener("click", function () {
      const checkboxes = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]'
      );

      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.click();
        }
      });

      filterButtons.forEach((button) => button.classList.remove("active"));
      this.classList.add("active");
    });
  }

  // Handle individual filter button clicks (multi-select enabled)
  filterButtons.forEach((button) => {
    if (button.classList.contains("btn-view-all")) return;

    button.addEventListener("click", function () {
      const filterValue = this.textContent.trim();
      const checkboxes = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]'
      );

      const matchedCheckbox = Array.from(checkboxes).find((checkbox) => {
        const label = checkbox.nextElementSibling;
        return label && label.textContent.trim() === filterValue;
      });

      if (!matchedCheckbox) return;

      // Toggle checkbox state
      matchedCheckbox.click();

      // Toggle button active state
      this.classList.toggle("active");

      // If no checkboxes are selected → reactivate "View All"
      const anyChecked = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]:checked'
      ).length > 0;

      if (viewAllButton) {
        viewAllButton.classList.toggle("active", !anyChecked);
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  initCollectionFilters();
  const readMoreHandler = initReadMore();
  document.addEventListener("click", readMoreHandler);
});

function initReadMore() {
  // Initialize state for all existing elements
  const readMoreWrappers = document.querySelectorAll(".read-more-wrapper");
  readMoreWrappers.forEach((wrapper) => {
    const content = wrapper.querySelector(".read-more-content-container");
    const button = wrapper.querySelector(".read-more-btn");

    if (!content || !button) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Check if text is longer than maxChars
    if (textLength > maxChars) {
      // Add collapsed class if not exists
      if (!content.classList.contains("collapsed")) {
        content.classList.add("collapsed");
      }

      // Show button
      button.style.display = "block";
    } else {
      // Remove collapsed and expanded classes
      content.classList.remove("collapsed", "expanded");

      // Hide button
      button.style.display = "none";
    }
  });

  // Return the event listener function
  return function (event) {
    const button = event.target.closest(".read-more-btn");
    if (!button) return;

    const wrapper = button.closest(".read-more-wrapper");
    const content = wrapper.querySelector(".read-more-content-container");
    if (!content) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Only handle if text is longer than maxChars
    if (textLength > maxChars) {
      if (content.classList.contains("collapsed")) {
        content.classList.remove("collapsed");
        content.classList.add("expanded");
        button.textContent = "Read less";
      } else {
        content.classList.remove("expanded");
        content.classList.add("collapsed");
        button.textContent = "Read more";
      }
    }
  };
}
